import React, { createContext, useEffect, useReducer, useState } from 'react'
import jwtDecode from 'jwt-decode'
import axios from '../../axios'
import { MatxLoading } from 'app/components'
import { getNavigationByUser, SET_USER_NAVIGATION } from 'app/redux/actions/NavigationAction'
import { useDispatch, useSelector } from 'react-redux'
import { navigations } from 'app/navigations'
import { truncate } from 'lodash'
import { setUserNavigation } from 'app/redux/reducers/NavigationReducer'

const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
    permissions: null,
}

const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false
    }

    const decodedToken = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decodedToken.exp > currentTime
}

const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload

            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
            }
        }
        case 'LOGIN': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'SET_PERMISSIONS_USER': {
            const { permissions } = action.payload

            return {
                ...state,
                permissions,
            }
        }
        case SET_USER_NAVIGATION: {
            const { navigations } = action.payload

            return {
                ...state,
                navigations
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'REGISTER': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'FORGOTPASSWORD': {

            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'CHANGEPASSWORD': {
            const { user } = action.payload
            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'RESETPASSWORD': {

            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    register: () => Promise.resolve(),
    forgotpassword: () => Promise.resolve(),
    changePassword: () => Promise.resolve(),
    resetpassword: () => Promise.resolve(),
})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const newDispatch = useDispatch();
    const select = useSelector(state => state);

    // console.log(select);

    const login = async (email, password) => {
        const response = await axios.post('/admin/auth/login-anunciante', {
            email,
            password,
        })

        const { tokens, user, bloqueado } = response.data

        if (tokens == undefined || user == undefined) {
            return {
                status: false,
                message: response.data.message
            };
        } else {
            setSession(tokens.access.token)
            localStorage.setItem('email', email)
            localStorage.setItem('user', user.id)
            localStorage.setItem('type', user.type)
            localStorage.setItem('bloqueado', bloqueado)
            localStorage.setItem('reloadCount', 0)

            dispatch({
                type: 'LOGIN',
                payload: {
                    user,
                },
            })

            dispatch({
                type: 'SET_PERMISSIONS_USER',
                payload: {
                    permissions: user?.profile?.permissions ?? []
                },
            });

            // Filtra as navegações com base nas permissões do usuário
            const filteredNavigations = getNavigationByUser(user, navigations); // `navigations` pode ser a sua lista completa de navegação
            newDispatch(setUserNavigation(filteredNavigations)) 

            return {
                status: true
            }
        }
    }

    const register = async (email, username, password) => {
        const response = await axios.post('/api/auth/register', {
            email,
            username,
            password,
        })

        const { accessToken, user } = response.data

        setSession(accessToken)

        dispatch({
            type: 'REGISTER',
            payload: {
                user,
            },
        })
    }

    const logout = async() => {
        let email = localStorage.getItem('email');
        
        const response = await axios.post('/admin/auth/logout',{
            email,
        })
        localStorage.removeItem("email");
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }

    const forgotpassword = async (email) => {
        const response = await axios.post('/admin/auth/forgot-password', {
            email,
        })
        // const { accessToken, user } = response.data
        //const { tokens, user } = response.data

        //setSession(tokens.access.token)

        dispatch({
            type: 'FORGOTPASSWORD',
           
        })

        return response;
    }

    const changePassword = async (email) => {
        const response = await axios.post('/admin/auth/forgot-password', {
            email,
        
        })
        // const { accessToken, user } = response.data
        //const { tokens, user } = response.data

        //setSession(tokens.access.token)

        dispatch({
            type: SET_USER_NAVIGATION,
           
        })
    }

    const resetpassword = async (token, password) => {
    
        const response = await axios.post(`/admin/auth/reset-password/?token=${token}`, { password });
        // const { accessToken, user } = response.data
        //const { tokens, user } = response.data

        //setSession(tokens.access.token)

        dispatch({
            type: 'RESETPASSWORD',
           
        })

        return response
    }

    useEffect(() => {
        (async () => {
            try {
                const accessToken = window.localStorage.getItem('accessToken')

                if (accessToken && isValidToken(accessToken)) {
                    setSession(accessToken)
                    const response = await axios.get('/clientes/auth/profile')
                    const { user } = response.data

                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: true,
                            user,
                        },
                    })

                    dispatch({
                        type: 'SET_PERMISSIONS_USER',
                        payload: {
                            permissions: user?.profile?.permissions ?? []
                        },
                    });

                    // Filtra as navegações com base nas permissões do usuário
                    const filteredNavigations = getNavigationByUser(user, navigations); // `navigations` pode ser a sua lista completa de navegação
                    newDispatch(setUserNavigation(filteredNavigations)) 

                } else {
                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                login,
                logout,
                register,
                forgotpassword,
                resetpassword,
                changePassword
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
